import { Injectable } from '@angular/core';
import { environment } from '@app/env';
import { ContactDto } from '@app/shared/modules/evc-api/models/contact.dto';
import { SmallBizStoreModel } from 'src/app/modules/evc-small-biz/stores/small-biz-store.model';
import { ChargingStationOutboundFormModel } from './form.model';

@Injectable()
export class ChargingStationOutboundFormMapper {
  constructor() {}

  public map(): ChargingStationOutboundFormModel {
    return {
      vatNumber: '',
      company: '',
      firstName: '',
      lastName: '',
      telephone: '',
      email: '',
      consent: false,
      alreadyClient: false,
    };
  }

  public payload(model: ChargingStationOutboundFormModel, lang: string, products: SmallBizStoreModel): ContactDto {
    return {
      companyNumber: model.vatNumber,
      companyName: model.company,
      lang,
      firstName: model.firstName,
      lastName: model.lastName,
      phoneNumber: model.telephone,
      email: model.email,
      recap: this.getRecap(products),
      customer: model.alreadyClient,
      consent: model.consent,
    };
  }

  private getRecap(products: SmallBizStoreModel): string {
    if (!products.chargeCardsAmount) {
      return `${environment.maxChargingStations} charging stations`;
    }

    return `${environment.maxChargingStations} charging stations & ${products.chargeCardsAmount} charging cards`;
  }
}
